import { request } from './request'


const clockApi = {
  add: params => {
    let newParam = {
      ...params,
      openid: window.openid,
      _t: new Date().getTime()
    }
    return request({
      url: "/Clockin/Add",
      data: newParam,
      method: "POST"
    })
  },
  getList: params => {
    let newParams = {
      ...params,
      openid: window.openid,
      _t:new Date().getTime()
    }
    return request({
      url: "/Clockin/GetUserList",
      params: newParams,
    })
  }
}

export default clockApi